import { render, staticRenderFns } from "./UserPages.vue?vue&type=template&id=19b54db3"
import script from "./UserPages.vue?vue&type=script&lang=js"
export * from "./UserPages.vue?vue&type=script&lang=js"
import style0 from "./UserPages.vue?vue&type=style&index=0&id=19b54db3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports